const useSheetOffscreenSize = ({
  snapPoints,
  position,
  screenSize
}) => {
  const maxPercentOpened = snapPoints[0] / 100;
  const percentOpened = (snapPoints[position] || 0) / 100;
  const percentHidden = 1 - maxPercentOpened - percentOpened;
  const offscreenSize = percentHidden * screenSize;
  return offscreenSize;
};
export {
  useSheetOffscreenSize
};
//# sourceMappingURL=useSheetOffscreenSize.js.map
